import { defineMessages } from 'react-intl';

const messages = defineMessages({
  validateAddress: {
    defaultMessage: 'Validate Address',
    description: 'editOrder.validateAddress',
    id: 'Jmb/Mv',
  },
  revert: {
    description: 'editOrder.revertToOriginal',
    defaultMessage: 'Revert',
    id: '3mHwP3',
  },
});

export default messages;
